import type { ReactNode } from 'react';
import { ProfileCircle } from './ProfileCircle';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';

export const BottomSheetPlayerDetails = ({ detailsToggle }: { detailsToggle: ReactNode }) => {
  const { offer, boot } = useContext(CheckoutContext);
  // The Builder game-name override drives only the native Apple Pay sheet label
  // (ACDEV-29232), not this visible publisher header (ACDEV-29510).
  const companyName = boot?.checkoutTheme?.publisherName ?? '';
  const offerName = offer?.displayName ?? offer?.name ?? '';

  return (
    <div data-testid="player-details" className="flex flex-col w-full mb-3 font-semibold">
      <div className="flex flex-row items-center gap-3 min-w-0 pr-8">
        <ProfileCircle />
        <div className=" truncate min-w-0" title={companyName}>
          {companyName}
        </div>
      </div>
      <div className="flex flex-row items-center justify-between gap-5 mt-3 ">
        <div className="truncate min-w-0" title={offerName}>
          {offerName}
        </div>
        {detailsToggle}
      </div>
    </div>
  );
};
